module.exports = __webpack_public_path__ + "img/choose-up-13_4.cfb93862.png";